import { FC, useCallback, useMemo } from "react";
import GenericButton from "@/components/forms/inputs/button/genericButton";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { KaerIcon } from "@/icons/kaerIcon";

type NavigateTo = "managerPortal" | "userPortal";

interface PortalConfig {
  icon: "employee" | "user";
  titleKey: string;
  subdomain: "manage" | "portal";
}

const portalConfig: Record<NavigateTo, PortalConfig> = {
  managerPortal: {
    icon: "employee",
    titleKey: "navigate_to_managerportal",
    subdomain: "manage",
  },
  userPortal: {
    icon: "user",
    titleKey: "navigate_to_userportal",
    subdomain: "portal",
  },
};

interface Props {
  navigateTo: NavigateTo;
}

const QuickLinkWrapper: FC<Props> = ({ navigateTo }) => {
  const { t } = useTranslation();

  const { icon, titleKey, subdomain } = useMemo(
    () => portalConfig[navigateTo],
    [navigateTo]
  );

  const openPortal = useCallback(() => {
    window.open(
      `https://${subdomain}.health-kaer.de`,
      "_blank",
      "noopener,noreferrer"
    );
  }, [subdomain]);

  return (
    <Tooltip title={t(titleKey)} placement="left">
      <GenericButton variant="icon" color="white" onClick={openPortal}>
        <KaerIcon icon={icon} color="#FFF" />
      </GenericButton>
    </Tooltip>
  );
};

export default QuickLinkWrapper;
